<div class="verification-sales-process-list-container">
  <button  [disabled]="!(userPermissions | async).facility.write" mat-stroked-button color="primary"
           class="ofwca-add-button" (click)="addVerificationSalesProcess()"><mat-icon>add</mat-icon> Dodaj formularz</button>
  <table mat-table [dataSource]="dataSource" multiTemplateDataRows>

    <!-- Position Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef> ID </th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
        {{element.id}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data wygenerowania </th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
        {{element.createdAt | date:'y-MM-dd '}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status formularza</th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
        <ng-container *ngIf="element.createdBy">
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy.username}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="download">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">

        <button  matTooltip="Generuj plik pdf"  (click)="downloadCertificates(element.id)"  mat-stroked-button color="accent"  ><mat-icon>picture_as_pdf</mat-icon></button>
      </td>
    </ng-container>

    <ng-container matColumnDef="upload">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">

        <button matTooltip="Dodaj skan"  (click)="addDocument(element)"  mat-stroked-button color="accent"><mat-icon>post_add</mat-icon></button>
      </td>
    </ng-container>

    <ng-container matColumnDef="downloadAttachment">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">

        <button [disabled]="!element.document"  matTooltip="Pobierz dokument" (click)="getDocument(facilityObject.address.uuid, element.document.uuid)" mat-stroked-button color="primary"><mat-icon>download</mat-icon></button>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">

        <button *ngIf="(userPermissions | async).facility.admin_root"  [disabled]="!(userPermissions | async).facility.admin_root" matTooltip="Usuń" (click)="deleteCertificates(element.id)"  mat-stroked-button color="warn"><mat-icon>delete</mat-icon></button>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element"  (click)="expandElement(element)">
  <mat-icon>expand_more</mat-icon>
        <mat-menu #menu="matMenu" xPosition="before">
        </mat-menu>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="expanded-row-td">
        <div class="expanded-data" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
          <div fxFlex="100" *ngIf="element == expandedElement">
            <app-verification-sales-process-view
              fxFlex="100"
              [partnerFacilityVerificationSalesProcess]="element"
              (modifyClicked)="modify = true"
            ></app-verification-sales-process-view>
          </div>

        </div>
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      class="table-row"
      mat-row *matRowDef="let element; let row; columns: displayedColumns;"
      [class.expanded-row]="expandedElement === element"
      [class.not-expanded-row]="expandedElement && expandedElement !== element"
      [ngClass]="{'overvoltage': element.overvoltage}"
    ></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" [ngClass]="{'overvoltageDisable': row.overvoltage}" class="expanded-data-row"></tr>
  </table>

  <mat-paginator [length]="totalData" [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
</div>

